import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Substrate} from '../models';

@Injectable()
export class SubstrateService extends IoService {
  protected model = Substrate;
  protected listUrl = '/substrates/';
}
